import { DIFFICULTY_COLOURS } from "@/components/event/labels";

/**
 * A grade of difficulty drawn as a strip going from green to red with a ▼ over it at the
 * grade (1 to 6), as wide as six squares of `size` and their gaps: the trails' bar
 * (event/DifficultyBar) and the events' (explore/DifficultyBar) both draw it.
 */
export function DifficultyScale({ grade, size }: { grade: number; size: number }) {
  const width = size * 6 + 2 * 5;
  // the middle of a grade's step, where its colour sits in the strip and the arrow points
  const middle = (g: number) => (g - 1) * (size + 2) + size / 2;
  const gradient = `linear-gradient(to right, ${DIFFICULTY_COLOURS.map((colour, i) => `${colour} ${((middle(i + 1) / width) * 100).toFixed(1)}%`).join(", ")})`;
  const height = Math.max(4, Math.round(size * 0.5));
  const half = Math.max(4, Math.round(size * 0.45));
  const tip = Math.round(half * 1.1);
  return (
    <span className="relative inline-flex flex-col" style={{ width, paddingTop: tip + 1 }} aria-hidden="true">
      <b
        className="absolute top-0 -translate-x-1/2 border-x-transparent border-t-ink"
        style={{ left: middle(grade), borderLeftWidth: half, borderRightWidth: half, borderTopWidth: tip, borderStyle: "solid", borderBottomWidth: 0 }}
      />
      <b className="block rounded-full" style={{ height, background: gradient }} />
    </span>
  );
}
